import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoiceFormRowLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormRowLine'
import { ProductType } from '@features/products/enums/productType'

import { PredefinedInvoiceValues } from '../../types/predefinedInvoiceValues'

export const getDefaultRowLine = (predefinedInvoiceValues?: PredefinedInvoiceValues): InvoiceFormRowLine => ({
  date: new Date(),
  discount: 0,
  productFromSearch: undefined,
  productId: null,
  productName: '',
  productType: predefinedInvoiceValues?.productType || ProductType.Goods,
  quantity: 1,
  totalExcludingVat: 0,
  totalIncludingVat: 0,
  type: InvoiceLineType.Row,
  unit: predefinedInvoiceValues?.unit ?? '',
  unitPrice: 0,
  vatRateId: predefinedInvoiceValues?.vatRateId,
  vatRatePercent: predefinedInvoiceValues?.vatRatePercent,
})
